import { CountryCodes } from 'constants/Countries'

export const BusinessDetailsFormKeys = {
  LEGAL_ENTITY_NAME: 'legalEntityName',
  LEGAL_ENTITY_REGISTRATION_NUMBER: 'legalEntityRegistrationNumber',
  INCOME_TAX_NUMBER: 'incomeTaxNumber',
  INDUSTRY_REFERENCE: 'industryReference',
  IS_OPERATION_LICENSE_REQUIRED: 'isOperationLicenseRequired',
  OPERATING_LICENSE_TYPE: 'operatingLicenseType',
  OPERATING_LICENSE_ISSUER: 'operatingLicenseIssuer',
} as const

export const BusinessDetailsFormKeyList = Object.values(BusinessDetailsFormKeys)

export const IncomeTaxNumberRegions = [CountryCodes.US]

export const RegionFallbackValue = 'default'
